/* The safe area is a border, not padding, so the sliding indicator (which fills the padding box) can't cover the
   active tab's focus ring. */
.bar { position: fixed; left: 0; right: 0; bottom: 0; z-index: 30; display: flex; background: var(--ink); border-top: 2px solid var(--ink); border-bottom: env(safe-area-inset-bottom) solid var(--ink); view-transition-name: tab-bar; }
.tab { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 5px; height: 60px; border-top: 3px solid transparent; color: var(--paper-60); font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; }
@media (min-width: 640px) {
  .bar { display: none; }
}
